const MANUFACTURING_ORDER_PREFIX = /^LSX-/i;

export const stripManufacturingOrderPrefix = (code: unknown): string =>
  String(code ?? "")
    .trim()
    .replace(MANUFACTURING_ORDER_PREFIX, "")
    .trim();

export const getManufacturingOrderCodesForDisplay = (
  codes: unknown,
): string[] => {
  if (!Array.isArray(codes)) return [];

  return codes.map(stripManufacturingOrderPrefix).filter(Boolean);
};
